import { AfterViewInit, Component, EventEmitter, OnInit } from '@angular/core';
import { AppConfigService } from '@core/appconfig.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyCode } from '@shared/enums/company-code';

@Component({
  selector: 'zbp-branded-confirm-password-modal',
  templateUrl: './branded-confirm-password-modal.component.html',
  styleUrls: ['./branded-confirm-password-modal.component.scss'],
  standalone: false
})
export class BrandedConfirmPasswordComponent implements OnInit, AfterViewInit {
  public focusOnPasswordInput = new EventEmitter<boolean>();
  password = '';
  title: string = 'Confirm Account Changes';
  showPassword: boolean = false;
  brand: string = CompanyCode.HighlightsPortal.toLowerCase();

  constructor(public activeModal: NgbActiveModal,
    private appConfig: AppConfigService) { }

  ngAfterViewInit() {
    this.focusOnPasswordInput.emit(true);
  }

  toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

  sendPassword(): void {
    this.activeModal.close(this.password);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  ngOnInit(): void {
    this.brand = this.appConfig.loginBrand?.toLowerCase();
  }
}
